import { extractTransferOps } from "./index.js";
import { collectWindowOps, groupActivity, distinctKey } from "../../src/build/index.js";

export const extract = extractTransferOps;
const RANK = { completed: 3, refused: 2, unrecorded: 1 };
export const informedness = (op) => (RANK[op.outcome] || 0) * 10000 + (op.output?.length || 0);
export const collect = (prompts) => collectWindowOps(prompts, { informedness });

// The remote PREFIX, not the object key. Object keys are unbounded and each one
// would be a singleton; the prefix is the thing a reader recognises.
export const groupBy = (op) => op.location || distinctKey("unnamed location", op);

export const build = (flat) => groupActivity(flat, {
  key: groupBy,
  label: (op) => op.location,
  seed: () => ({ kinds: {}, outcomes: {}, labels: [], uploads: 0, deletes: 0 }),
  fold: (g, op) => {
    g.kinds[op.kind] = (g.kinds[op.kind] || 0) + 1;
    g.outcomes[op.outcome] = (g.outcomes[op.outcome] || 0) + 1;
    if (op.kind === "upload") g.uploads += 1;
    if (op.kind === "delete") g.deletes += 1;
  },
  // Direction is the reading: data leaving the machine outlives the session and is
  // readable by other people, which a download is not.
  finish: (g) => {
    g.labels = [
      g.uploads ? `${g.uploads} sent out` : null,
      g.deletes ? `${g.deletes} deleted` : null,
    ].filter(Boolean);
  },
});

export const anchor = () => "s3";
export const ignore = ["output", "steps", "checks"];
